(function(){
  if (window.__bbcc) { window.__bbcc.init(); return; }
  var HEAT = [{key:'hot',label:'Hot',pips:3},{key:'medium',label:'Medium',pips:2},{key:'mild',label:'Mild',pips:1},{key:'none',label:'No heat',pips:0}];
  var FLAVOR = [{key:'fruity',label:'Fruity'},{key:'roasted',label:'Roasted red pepper'},{key:'smoky',label:'Smoky'}];
  var CELLS = [['#e8760f','#e2501a','#b5221e'],['#ec8a33','#e4622e','#a83634'],['#f1a646','#eb8350','#ae5555'],['#f6cb6e','#efa47e','#b47b7a']];
  var inView = new Set();
  var heatKey = function(y){ return y >= 75 ? 'hot' : y >= 50 ? 'medium' : y >= 25 ? 'mild' : 'none'; };
  var colKey = function(x){ return x <= 33 ? 'fruity' : x <= 66 ? 'roasted' : 'smoky'; };
  function syncSticky(){
    inView.forEach(function(r){ if (!r.isConnected) inView.delete(r); });
    document.documentElement.classList.toggle('bbcc-in-view', inView.size > 0);
  }
  function teardown(root){
    var st = root.__bbcc;
    if (st) { if (st.ro) st.ro.disconnect(); if (st.io) st.io.disconnect(); if (st.onResize) window.removeEventListener('resize', st.onResize); root.__bbcc = null; }
    inView.delete(root); syncSticky();
  }
  var reduceMotion = function(){ return window.matchMedia('(prefers-reduced-motion: reduce)').matches; };
  var esc = function(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); };

  function headerOffset(){
    var h = document.querySelector('store-header') || document.querySelector('.shopify-section-group-header-group');
    if (!h) return 0;
    var r = h.getBoundingClientRect();
    return r.bottom > 0 ? r.bottom : 0;
  }
  function scrollToEl(el, smooth, onlyIfNeeded){
    var off = headerOffset() + 16, r = el.getBoundingClientRect();
    if (onlyIfNeeded && r.top >= off && r.top < window.innerHeight * 0.5) return;
    window.scrollTo({top: Math.max(0, r.top + window.pageYOffset - off), behavior: smooth && !reduceMotion() ? 'smooth' : 'auto'});
  }

  function setup(root){
    root.setAttribute('data-ready', '1');
    var cfg;
    try { cfg = JSON.parse(root.querySelector('script[data-bbcc-config]').textContent); } catch (e) { return; }
    var uid = root.id || ('bbcc' + Math.random().toString(36).slice(2));
    var canCart = !!(window.Shopify && window.Shopify.shop);
    // Heat comes from the jar's height on the chart and the main flavor from its column, so they can never disagree
    var chilis = (cfg.chilis || []).filter(function(c){ return c.available || (cfg.otherSizes && c.otherAvailable); });
    chilis.forEach(function(c){
      c.heat = heatKey(c.y);
      var col = colKey(c.x);
      c.flavor = [col];
      if (c.also && c.also !== 'none' && c.also !== col) c.flavor.push(c.also);
    });
    var state = {heat:null, flavor:null, selected:null};
    var $ = function(s){ return root.querySelector(s); };
    var chart = $('.bbcc-chart'), plot = $('.bbcc-plot'), panel = $('.bbcc-panel'), slotsEl = $('.bbcc-slots');
    var heatOf = function(k){ return HEAT.filter(function(h){ return h.key === k; })[0] || HEAT[3]; };
    var flavorLabel = function(k){ var f = FLAVOR.filter(function(x){ return x.key === k; })[0]; return f ? f.label : ''; };
    var flavorText = function(c){ return c.flavor.map(flavorLabel).join(' and '); };
    var matches = function(c){ return (!state.heat || c.heat === state.heat) && (!state.flavor || c.flavor.indexOf(state.flavor) > -1); };
    var find = function(id){ return chilis.filter(function(c){ return c.id === id; })[0]; };
    var jarEl = function(id){ return root.querySelector('.bbcc-jar[data-id="' + id + '"]'); };
    panel.id = uid + '-details';

    // Background squares and the slots that hold the jars
    var cells = $('.bbcc-cells');
    CELLS.forEach(function(row, r){ row.forEach(function(color, f){
      var d = document.createElement('div'); d.className = 'bbcc-cell'; d.style.setProperty('--cell', color);
      d.dataset.heat = HEAT[r].key; d.dataset.flavor = FLAVOR[f].key; cells.appendChild(d);
      var s = document.createElement('div'); s.className = 'bbcc-slot'; s.style.setProperty('--cell', color);
      s.style.setProperty('--r', 3 + r * 2); s.style.setProperty('--c', f + 1);
      s.dataset.heat = HEAT[r].key; s.dataset.flavor = FLAVOR[f].key; s.dataset.r = r; s.dataset.f = f; slotsEl.appendChild(s);
    }); });

    function axisButton(group, item){
      var b = document.createElement('button'); b.type = 'button'; b.className = 'bbcc-axis';
      b.textContent = item.label; b.setAttribute('aria-pressed', 'false'); b.dataset.key = item.key;
      b.addEventListener('click', function(){ state[group] = state[group] === item.key ? null : item.key; render(); });
      return b;
    }
    HEAT.forEach(function(h){ $('.bbcc-y').appendChild(axisButton('heat', h)); });
    FLAVOR.forEach(function(f){ $('.bbcc-x').appendChild(axisButton('flavor', f)); });

    // Jars go into their square, hottest first, so keyboard order follows the chart
    chilis.slice().sort(function(a, b){ return b.y - a.y || a.x - b.x; }).forEach(function(c){
      var r = HEAT.indexOf(heatOf(c.heat)), f = ['fruity','roasted','smoky'].indexOf(colKey(c.x));
      var b = document.createElement('button'); b.type = 'button'; b.className = 'bbcc-jar'; b.dataset.id = c.id;
      b.style.setProperty('--x', c.x); b.style.setProperty('--y', c.y);
      b.setAttribute('aria-pressed', 'false'); b.setAttribute('aria-controls', panel.id);
      b.innerHTML = '<img src="' + esc(c.img) + '" alt="" width="60" height="60"><span class="bbcc-name">' + esc(c.name) + '</span>' +
        '<span class="bbcc-vh">, ' + esc(heatOf(c.heat).label) + ', ' + esc(flavorText(c)) + (c.available ? '' : ', glass jar sold out') + '</span>';
      b.querySelector('img').addEventListener('error', function(){ this.removeAttribute('src'); this.classList.add('is-missing'); });
      b.addEventListener('click', function(){ select(c.id); });
      root.querySelector('.bbcc-slot[data-r="' + r + '"][data-f="' + f + '"]').appendChild(b);
    });


    function render(){
      // A chosen chili that no longer matches the filters is cleared from the details card
      if (state.selected) {
        var sel = find(state.selected);
        if (!sel || !matches(sel)) { state.selected = null; renderEmpty(); fitPanel(); }
      }
      root.querySelectorAll('.bbcc-y .bbcc-axis').forEach(function(b){ b.setAttribute('aria-pressed', String(b.dataset.key === state.heat)); });
      root.querySelectorAll('.bbcc-x .bbcc-axis').forEach(function(b){ b.setAttribute('aria-pressed', String(b.dataset.key === state.flavor)); });
      root.querySelectorAll('.bbcc-cell, .bbcc-slot').forEach(function(d){
        var on = (!state.heat || d.dataset.heat === state.heat) && (!state.flavor || d.dataset.flavor === state.flavor);
        d.classList.toggle('is-dim', !on);
      });
      var n = 0;
      chilis.forEach(function(c){
        var el = jarEl(c.id), on = matches(c);
        if (on) n++;
        el.disabled = !on;
        el.setAttribute('aria-pressed', String(state.selected === c.id));
      });
      var filtered = !!(state.heat || state.flavor);
      $('.bbcc-count').textContent = filtered ? (n ? n + (n === 1 ? ' chili matches' : ' chilis match') : 'No chilis match') : '';
    }

    function isSide(){ return panel.getBoundingClientRect().left >= chart.getBoundingClientRect().right - 1; }

    function fitPanel(){
      panel.style.height = ''; panel.classList.remove('is-auto');
      if (!isSide()) return;
      panel.style.height = plot.offsetHeight + 'px';
      if (panel.scrollHeight > panel.clientHeight + 1) { panel.style.height = ''; panel.classList.add('is-auto'); }
    }

    function select(id){
      var c = find(id); if (!c) return;
      state.selected = id; render(); renderPanel(c); fitPanel();
      var h = panel.querySelector('.bbcc-ptitle');
      if (!isSide()) scrollToEl(panel, true, true);
      h.focus({preventScroll:true});
    }

    function backToChart(){
      var el = state.selected && jarEl(state.selected);
      if (!el || el.disabled) el = root.querySelector('.bbcc-jar:not(:disabled)') || root.querySelector('.bbcc-axis');
      el.focus({preventScroll:true});
      if (!isSide()) el.scrollIntoView({block:'center', behavior: reduceMotion() ? 'auto' : 'smooth'});
    }

    var bundle = function(){
      if (!cfg.bundleUrl || !cfg.bundleText) return '';
      var text = String(cfg.bundleText).trim(), arrow = '';
      if (/>\s*$/.test(text)) { text = text.replace(/\s*>\s*$/, ''); arrow = '&nbsp;<span class="bbcc-arrow" aria-hidden="true">&gt;</span>'; }
      return '<a class="bbcc-bundle" href="' + esc(cfg.bundleUrl) + '">' + esc(text) + arrow + '</a>';
    };

    function renderEmpty(){
      panel.innerHTML = '<div class="bbcc-pbody bbcc-empty"><h3 class="bbcc-ptitle">Find your chili</h3>' +
        '<p>Every jar sits where it lands on two scales: how hot it is, and whether it tastes fruity, like roasted red pepper, or smoky.</p>' +
        '<p>Choose any jar for the details.</p></div>';
    }

    function renderPanel(c){
      var h = heatOf(c.heat), pips = '';
      for (var i = 0; i < 3; i++) pips += '<i class="' + (i < h.pips ? 'on' : '') + '"></i>';
      var primary = !c.available
        ? '<a class="bbcc-btn" href="' + esc(c.url) + '">See available sizes</a>'
        : canCart
          ? '<button type="button" class="bbcc-btn" data-add>Add to cart</button>'
          : '<a class="bbcc-btn" href="' + esc(c.url) + '">Shop ' + esc(c.name) + '</a>';
      var link = cfg.showLink ? '<a class="bbcc-link" href="' + esc(c.url) + '">View all sizes of ' + esc(c.name) + '</a>' : '';
      var uses = (cfg.showUses && c.uses && c.uses.length)
        ? '<p class="bbcc-useslabel" id="' + uid + '-uses">Great for</p><ul class="bbcc-uses" aria-labelledby="' + uid + '-uses">' + c.uses.map(function(u){ return '<li>' + esc(u) + '</li>'; }).join('') + '</ul>' : '';
      panel.innerHTML =
        '<div class="bbcc-pbody bbcc-fade">' +
        '<button type="button" class="bbcc-back">Back to chart</button>' +
        (c.hero ? '<a class="bbcc-heroWrap" href="' + esc(c.url) + '" tabindex="-1" aria-hidden="true"><img class="bbcc-hero" src="' + esc(c.hero) + '" alt="" width="320" height="320"></a>' : '') +
        '<h3 class="bbcc-ptitle" tabindex="-1"><a class="bbcc-plink" href="' + esc(c.url) + '">' + esc(c.name) + '</a></h3>' +
        (c.origin ? '<p class="bbcc-origin">' + esc(c.origin) + '</p>' : '') +
        '<dl class="bbcc-meta"><dt>Heat</dt><dd><span class="bbcc-pips" aria-hidden="true">' + pips + '</span>' + h.label + '</dd>' +
        '<dt>Flavor</dt><dd>' + esc(flavorText(c)) + '</dd></dl>' +
        (c.desc ? '<p>' + esc(c.desc) + '</p>' : '') + uses +
        (c.available ? '<div class="bbcc-buy"><span>' + esc(c.size) + '</span><strong>' + esc(c.price) + '</strong></div>' : '<div class="bbcc-buy"><p class="bbcc-soldout">Glass jar sold out. Other sizes are available.</p></div>') +
        '<div class="bbcc-btns">' + primary + link + '</div>' + bundle() +
        '<p class="bbcc-note" role="status"></p>' +
        '</div>';
      panel.querySelector('.bbcc-back').addEventListener('click', backToChart);
      var hero = panel.querySelector('.bbcc-hero');
      if (hero) hero.addEventListener('error', function(){ this.parentNode.hidden = true; fitPanel(); });
      var add = panel.querySelector('[data-add]');
      if (add) add.addEventListener('click', function(){ addToCart(c, add); });
    }

    // Mirrors the theme's own product form: same request, cart icon update, drawer behavior and events
    async function addToCart(c, btn){
      if (btn.getAttribute('aria-disabled') === 'true') return;
      var t = window.theme || {}, settings = t.settings || {}, routes = t.routes || {};
      var cartUrl = routes.cart || '/cart', addUrl = routes.cartAdd || '/cart/add';
      var note = panel.querySelector('.bbcc-note');
      var drawer = document.querySelector('cart-drawer');
      var shown = false;
      var showError = function(msg){ shown = true; note.textContent = Array.isArray(msg) ? msg.join(' ') : (msg || 'Couldn\u2019t add this to your cart. Please try again.'); };
      if (settings.vibrateOnATC && navigator.vibrate) navigator.vibrate(100);
      note.textContent = '';
      btn.setAttribute('aria-disabled', 'true'); btn.textContent = 'Adding\u2026';
      var fd = new FormData();
      fd.append('id', c.variantId); fd.append('quantity', 1);
      var sections = 'cart-icon-bubble';
      var sec = drawer && drawer.closest('.shopify-section');
      if (sec) sections += ',' + sec.id.replace('shopify-section-', '');
      fd.append('sections_url', window.location.pathname); fd.append('sections', sections);
      var ok = false;
      try {
        var oldRes = await fetch(cartUrl + '.js'); if (!oldRes.ok) throw new Error(oldRes.status);
        var oldCart = await oldRes.json();
        var res = await fetch(addUrl, {method:'POST', headers:{'Accept':'application/javascript', 'X-Requested-With':'XMLHttpRequest'}, body: fd});
        var data = await res.json();
        var error = typeof data.description === 'string' ? data.description : data.message;
        if (data.errors && typeof data.errors === 'object') error = Object.entries(data.errors).map(function(e){ return [].concat(e[1]).join(', '); });
        if (data.status) showError(error);
        if (!res.ok) throw new Error(res.status);
        ok = true;
        if (settings.afterAtc === 'page') {
          setTimeout(function(){ window.location.href = cartUrl; }, 300);
        } else {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble && data.sections && data.sections['cart-icon-bubble']) bubble.innerHTML = data.sections['cart-icon-bubble'];
          setTimeout(function(){
            if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(data, settings.afterAtc ? settings.afterAtc === 'drawer' : true);
            else window.location.href = cartUrl;
          }, 700);
        }
        var newRes = await fetch(cartUrl + '.js'); if (!newRes.ok) throw new Error(newRes.status);
        var newCart = await newRes.json();
        var old = oldCart.items.filter(function(i){ return i.variant_id === data.variant_id; })[0];
        btn.dispatchEvent(old
          ? new CustomEvent('on:line-item:change', {bubbles:true, detail:{cart:newCart, variantId:data.variant_id, oldQuantity:old.quantity, newQuantity: old.quantity === data.quantity ? old.quantity : data.quantity}})
          : new CustomEvent('on:cart:add', {bubbles:true, detail:{cart:newCart, variantId:data.variant_id}}));
      } catch (err) {
        if (!ok && !shown) showError();
        btn.dispatchEvent(new CustomEvent('on:cart:error', {bubbles:true, detail:{error: note.textContent}}));
        if (!ok && drawer && typeof drawer.refresh === 'function') drawer.refresh(true);
      } finally {
        btn.removeAttribute('aria-disabled');
        btn.textContent = ok ? 'Added to cart' : 'Add to cart';
        if (ok) setTimeout(function(){ btn.textContent = 'Add to cart'; }, 1400);
      }
    }

    // Watchers are kept on the chart so they can be stopped if the section is removed or reloaded in the theme editor
    var st = {ro:null, io:null, onResize:null};
    if (window.ResizeObserver) { st.ro = new ResizeObserver(function(){ fitPanel(); }); st.ro.observe(root); }
    else { st.onResize = fitPanel; window.addEventListener('resize', fitPanel); }

    // While the chart is on screen, hide the page's sticky add to cart bar so it can't be mistaken for the chili shown here
    if (cfg.hideSticky && window.IntersectionObserver) {
      st.io = new IntersectionObserver(function(entries){
        if (entries[entries.length - 1].isIntersecting) inView.add(root); else inView.delete(root);
        syncSticky();
      });
      st.io.observe($('.bbcc-wrap'));
    }
    root.__bbcc = st;

    renderEmpty(); render(); fitPanel();
  }

  function init(){ document.querySelectorAll('.bbcc[data-bbcc]:not([data-ready])').forEach(setup); }

  // Links to the chart's anchor (for example in a product description) scroll to it, clear of the sticky header
  function jumpTo(hash, smooth){
    if (!hash || hash.length < 2) return false;
    var target = document.getElementById(decodeURIComponent(hash.slice(1)));
    if (!target || !target.closest('.bbcc')) return false;
    scrollToEl(target, smooth); target.focus({preventScroll:true});
    return true;
  }
  document.addEventListener('click', function(e){
    var a = e.target.closest ? e.target.closest('a[href*="#"]') : null;
    if (!a) return;
    var u = new URL(a.getAttribute('href'), window.location.href);
    if (u.pathname !== window.location.pathname) return;
    if (jumpTo(u.hash, true)) { e.preventDefault(); if (window.history.replaceState) window.history.replaceState(null, '', u.hash); }
  });
  window.addEventListener('load', function(){ setTimeout(function(){ jumpTo(window.location.hash, false); }, 50); });
  // Keep sticky column titles just below the store header, which can slide in and out
  var topQueued = false;
  function updateTop(){
    topQueued = false;
    var t = headerOffset() + 'px';
    document.querySelectorAll('.bbcc[data-bbcc]').forEach(function(r){ r.style.setProperty('--bbcc-top', t); });
  }
  function queueTop(){ if (!topQueued) { topQueued = true; window.requestAnimationFrame(updateTop); } }
  window.addEventListener('scroll', queueTop, {passive:true});
  window.addEventListener('resize', queueTop);
  document.addEventListener('shopify:section:load', function(){ init(); queueTop(); });
  document.addEventListener('shopify:section:unload', function(e){
    if (e.target && e.target.querySelectorAll) e.target.querySelectorAll('.bbcc[data-ready]').forEach(teardown);
    syncSticky();
  });

  window.__bbcc = {init: function(){ init(); queueTop(); }};
  init(); updateTop();
})();
